import { VillagesMortgageAllowedContainer } from '../../containers/filters/VillageMortgageAllowedContainer';
import { EFilterType, IDefaultFilter } from '../../types/filters';
import { isVillageMortgageFilterAvailable } from '../../utils/availability';

export const villageMortgageAllowed: IDefaultFilter = {
  availability: isVillageMortgageFilterAvailable(),
  component: VillagesMortgageAllowedContainer,
  type: EFilterType.Default,
};
